<template>
  <GuBadge :variant="BADGE_TYPE_DICTIONARY[params.data.active]">
    {{ text }}
  </GuBadge>
</template>

<script setup>
import { computed, toRefs } from 'vue'
import { GuBadge } from '@shared/gu-components/badge'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const BADGE_TYPE_DICTIONARY = {
  false: 'danger',
  true: 'success',
}

const text = computed(() => (params.value.data.active ? 'Enabled' : 'Disabled'))
</script>
